import { useTranslation } from 'react-i18next';
import { MAX_SUPPORT_QUESTIONS } from './supportFormCatalog';

const resolveLabel = (t, item, fallback) => {
  if (!item) return fallback;
  const translated = t(item.labelKey, {
    defaultValue: item.label || fallback,
    returnObjects: true,
  });
  if (translated && typeof translated === 'object') {
    return translated.label || item.label || fallback;
  }
  return translated;
};

/**
 * Renderer genérico: 1–3 opción + 1 abierto opcional (hybrid / dynamic).
 * types: single_select | multi_select | open_text
 * Cambiar preguntas: supportFormCatalog.js (+ i18n), no este archivo.
 */
const SupportRequestForm = ({ questions = [], answers = {}, onChange }) => {
  const { t } = useTranslation();
  const visible = (questions || []).slice(0, MAX_SUPPORT_QUESTIONS);

  const setValue = (key, value) => {
    onChange({ ...answers, [key]: value });
  };

  const toggleMulti = (key, optionValue) => {
    const current = Array.isArray(answers[key]) ? answers[key] : [];
    const next = current.includes(optionValue)
      ? current.filter((v) => v !== optionValue)
      : [...current, optionValue];
    setValue(key, next);
  };

  return (
    <>
      {visible.map((q) => {
        const label = resolveLabel(t, q, q.key);
        const value = answers[q.key] ?? (q.type === 'multi_select' ? [] : '');

        if (q.type === 'single_select') {
          return (
            <div className="mb-2" key={q.key}>
              <label className="form-label">
                {label}
                {q.required ? ' *' : ''}
              </label>
              <select
                className="form-select"
                value={value}
                required={!!q.required}
                onChange={(e) => setValue(q.key, e.target.value)}
              >
                <option value="">
                  {t('semanticSearch.form.selectPlaceholder', { defaultValue: 'Seleccione…' })}
                </option>
                {(q.options || []).map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {resolveLabel(t, opt, opt.value)}
                  </option>
                ))}
              </select>
            </div>
          );
        }

        if (q.type === 'multi_select') {
          return (
            <div className="mb-2" key={q.key}>
              <div className="form-label">
                {label}
                {q.required ? ' *' : ''}
              </div>
              {(q.options || []).map((opt) => (
                <div className="form-check" key={opt.value}>
                  <input
                    id={`q-${q.key}-${opt.value}`}
                    type="checkbox"
                    className="form-check-input"
                    checked={Array.isArray(value) && value.includes(opt.value)}
                    onChange={() => toggleMulti(q.key, opt.value)}
                  />
                  <label className="form-check-label" htmlFor={`q-${q.key}-${opt.value}`}>
                    {resolveLabel(t, opt, opt.value)}
                  </label>
                </div>
              ))}
            </div>
          );
        }

        return (
          <div className="mb-2" key={q.key}>
            <label className="form-label">
              {label}
              {q.required ? ' *' : ''}
            </label>
            <textarea
              className="form-control"
              rows={2}
              value={value}
              required={!!q.required}
              onChange={(e) => setValue(q.key, e.target.value)}
            />
          </div>
        );
      })}
    </>
  );
};

export default SupportRequestForm;
